import React, { memo, useState, useEffect } from "react";
import { getEnterpriseData } from "@/api/home";
import styles from "./style.module.less";
import Empty from "../../../empty";
import { Iprops } from "../..";
const getIndex = (index: number) => {
  return index.toString().length === 1 ? `0${index}` : index;
};
export interface enterItem {
  title: string | null;
  content: string | null;
  pcUrl: string | null;
  applicationBaseInfoList: {
    homeUrl: string;
    deploymentType: number;
    deepLink: string | null;
    eGovHomeUrl: string | null;
    hostAppClient: number;
  }[];
  applicationKey: string | null;
  linkType?: 1 | 2 | 3;
  urlType?: 1 | 2 | 3;
  mobileUrl: string | null;
  applicationId?: string | null;
  applicationName?: string | null;
  enterpriseId: string;
}
export interface enterInterface {
  enterprises: enterItem[];
  enterpriseSetting?: {
    moduleName: string;
    description: string;
  };
}
export const ContentFour = memo(
  ({ data, onItemClick }: { data: enterItem[]; onItemClick: Function }) => (
    <div className={styles.content_four}>
      {data && data.length > 0 ? (
        data?.map((item: enterItem, idx: number) => (
          <div
            className={styles.topic_item}
            key={item.applicationId || idx}
            onClick={() => {
              console.log("urlType", item);
              onItemClick(item);
            }}
          >
            <div className={styles.wrapper_item_common}>
              <div className={styles.topic_index}>{getIndex(idx + 1)}</div>
              <div className={styles.topic_title}>
                {item.title} <div className={styles.bg_view} />
              </div>
            </div>
            <div className={styles.topic_desc}>{item.content} </div>
          </div>
        ))
      ) : (
        <div className={styles.empty_content}>
          <Empty />
        </div>
      )}
    </div>
  )
);
const Enterprises = memo(({ onAppOrLinkClick, t }: Iprops) => {
  const [serviceData, setServiceData] = useState<any>(null);

  useEffect(() => {
    getEnterpriseData().then((res: enterInterface) => {
      console.log(res, "res111");
      setServiceData(res);
    });
  }, []);

  return (
    <div className={styles.featured_service_wrapper}>
      {serviceData ? (
        <div className={styles.featured_service_content}>
          <span className={styles.txt13}>{serviceData?.enterpriseSetting?.moduleName}</span>
          <span className={styles.txt14}>{serviceData?.enterpriseSetting?.description}</span>
          <div>
            <ContentFour data={serviceData?.enterprises} onItemClick={onAppOrLinkClick} />
          </div>
        </div>
      ) : null}
    </div>
  );
});

export default Enterprises;
